import { render, staticRenderFns } from "./user_details.vue?vue&type=template&id=e7f365c6&scoped=true&"
import script from "./user_details.vue?vue&type=script&lang=js&"
export * from "./user_details.vue?vue&type=script&lang=js&"
import style0 from "./user_details.vue?vue&type=style&index=0&id=e7f365c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f365c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7f365c6')) {
      api.createRecord('e7f365c6', component.options)
    } else {
      api.reload('e7f365c6', component.options)
    }
    module.hot.accept("./user_details.vue?vue&type=template&id=e7f365c6&scoped=true&", function () {
      api.rerender('e7f365c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certification/user_details.vue"
export default component.exports